/**
 * Shared RTK Query base query for Stride admin API.
 */

import { API_BASE_URL } from '@/config/api'
import { getAuthToken } from '@/core/auth'
import { fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const strideBaseQuery = fetchBaseQuery({
  baseUrl: `${API_BASE_URL}/api/v2`,
  /** Bearer auth; avoid cross-origin cookies so CORS is simpler in production */
  credentials: 'same-origin',
  prepareHeaders: (headers, { getState }) => {
    let token: string | null = (getState() as { auth: { token: string | null } }).auth?.token
    if (!token) token = getAuthToken()
    if (token) headers.set('authorization', `Bearer ${token}`)
    return headers
  },
})
